import axios from "axios";
import {ACCOUNT_ME_INVOICE} from "constants/AuthConstant";
import { notification } from "antd";
import {LOGIN_ME_INVOICE} from "../constants/ApiConstant";
import dayjs from 'dayjs';

const service = axios.create({
  baseURL: process.env.REACT_APP_ME_INVOICE_URL,
  timeout: 60000,
});
const TOKEN_PAYLOAD_KEY = "authorization";
service.interceptors.request.use(
  async (config) => {
    const jwtToken = localStorage.getItem(ACCOUNT_ME_INVOICE) || null;
    if (jwtToken) {
      const tokenData = JSON.parse(jwtToken);
      const {access_token, username, password, taxCode, appId, expired_at} =
          tokenData;
      const now = new Date();
      const timeDiff = dayjs(now).diff(dayjs(expired_at), 'millisecond');
      if (!access_token || timeDiff >= 0) {
        const response = await axios.post(
          `${process.env.REACT_APP_API_ENDPOINT_URL}${LOGIN_ME_INVOICE}`,
          {
            username: username,
            password: password,
            taxCode: taxCode,
          }
        );
        if (response.data && response.data.success) {
          localStorage.setItem(ACCOUNT_ME_INVOICE, JSON.stringify({
            access_token: response.data.data,
            expired_at: now.setDate(now.getDate() + 7),
            ...response.data,
          }));
          config.headers[
              TOKEN_PAYLOAD_KEY
              ] = `Bearer ${response.data.access_token}`;
        }
      } else {
        config.headers[TOKEN_PAYLOAD_KEY] = `Bearer ${access_token}`;
      }
    }
    return config;
  },
  (error) => {
    notification.error({
      message: "Error",
    });
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    return response.data;
  },
  async (error) => {
    let notificationParam = {
      message: "",
    };
    if (error.response) {
      notificationParam.message = error.response.data?.data;
    } else {
      notificationParam.message = "Lỗi kết nối mạng";
    }

    if (!notificationParam.message) {
      notificationParam.message = "Vui lòng kiểm tra lại thông tin kết nối";
    }
    notification.error(notificationParam);

    return Promise.reject(error);
  }
);

export default service;
